import * as React from "react";

import styles from "./burger.module.css";

interface IProps {
  isOpen: boolean;
  onClick: () => void;
}

export default function Burger({ isOpen, onClick }: IProps) {
  return (
    <div className={styles.burger}>
      <input type="checkbox" checked={isOpen} onChange={onClick} />
      <span />
      <span />
      <span />
    </div>
  );
}
